import type { FrontendInstallContext } from "@p0security/integrations-installer";
import type { RedshiftAiIntegration } from "@p0security/integrations-redshift-ai-shared/types";
import { installedIds } from "@p0security/shared/install/installed";

type InstallContext = FrontendInstallContext<RedshiftAiIntegration>;

// copy of listInstalledKeys in packages/integrations/databricks-ai/frontend/src/options.ts
/** The keys of the installed `component` items. */
export const listInstalledKeys = (
  context: InstallContext,
  component: keyof RedshiftAiIntegration
) =>
  // The integration's config is loaded live, so it may not be here yet.
  new Set(context.config ? installedIds(component, context.config) : []);
